import { createChildListViewComponent } from 'factories/ChildListView'
import entityNames from 'options/entityNames'
import { isReadOnly } from 'helpers/formViews'
import SelectAlternate from './Select'

export default createChildListViewComponent({
  entityName: entityNames.products,
  childName: 'productAlternates',
  allowCreate: (self) => false,
  extraTableButtons: (self) => (
    <SelectAlternate
      onSelect={(product) =>
        self.props.onChange?.([
          ...(self.props.items ?? []),
          {
            id: Date.now() * -1,
            alternateBarcode: product.barcode,
            barcode: product.barcode,
            defaultSupplierName: product.preferredSupplierName,
            description: product.description,
            itemNumber: product.itemNumber,
            packageSizeUom: product.packageSizeUom,
            price: product.price,
          },
        ])
      }
      readOnly={isReadOnly(self)}
    />
  ),
  allowCustomize: (self) => true,
})()
